<script setup>
import { onMounted } from 'vue';
import PostsListView from '../PostsList.vue';
import { usePostsList } from 'dashboard/composables/usePostsList';
import { useStore } from 'dashboard/composables/store';

const store = useStore();

const {
  posts,
  uiFlags,
  filter,
  tab,
  message,
  fetchPosts,
  refreshAllPostTabs,
  handleToggleActive,
  handleFilterChange,
  handleSearch,
  handlePageChange,
  handleTabChange,
} = usePostsList({
  sponsored: false,
  sourceType: 'MENTIONED_INSTAGRAM',
});

onMounted(() => {
  fetchPosts();
  store.dispatch('facebookPages/get');
});
</script>

<template>
  <PostsListView
    header-title="Menções"
    post-type="mention"
    :ui-flags="uiFlags"
    :posts-list="posts"
    :initial-tab="tab"
    :initial-filter="filter"
    :initial-search-word="message"
    @filter-change="handleFilterChange"
    @search="handleSearch"
    @post-active-toggled="handleToggleActive"
    @current-page="handlePageChange"
    @tab-change="handleTabChange"
    @post-deleted="fetchPosts"
    @refresh="refreshAllPostTabs"
  />
</template>
